<template>
  <b-container fluid id="app" v-if="user_has_dashboard_permission">
    <b-row class="m-0">
      <b-col class="mt-2 mb-4 p-0" style="overflow: visible;">
        <b-row style="flex-flow: nowrap; min-height: 50px; overflow: visible;" class="white-box align-items-center mr-2 ml-2 pl-3 pr-0">
          <img style="width: 30px" src="@/assets/shoppub_logo_v3.svg" alt="shoppub_logo">
          <div class="context-tabs-wrapper ml-3 position-relative">
            <b-nav pills class="context-tabs flex-nowrap overflow-auto" ref="contextTabs" @scroll="onTabsScroll">
              <b-nav-item
                v-for="opt in sortedOptions"
                :key="opt.code"
                :active="selected.code === opt.code"
                @click.prevent="onSelectContext(opt)"
                :class="['px-2 py-1 text-nowrap', { pinned: isPinned(opt.code) }]">
                <span class="nav-item-wrap">
                  <span class="ctx-icon" v-html="getContextIcon(opt.code)"></span>
                  <span class="ctx-label">{{ opt.label }}</span>
                  <span v-if="opt.code !== 1" :class="['pin-btn', { visible: isPinned(opt.code) }]" @click.stop="togglePin(opt)" title="Fixar no topo">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pin-icon lucide-pin"><path d="M12 17v5"/><path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"/></svg>
                  </span>
                </span>
              </b-nav-item>
            </b-nav>
            <button 
              v-show="showLeftButton" 
              class="scroll-btn scroll-btn-left" 
              @click="scrollLeft"
              aria-label="Rolar para esquerda"
              type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m15 18-6-6 6-6"/>
              </svg>
            </button>
            <button 
              v-show="showRightButton" 
              class="scroll-btn scroll-btn-right" 
              @click="scrollRight"
              aria-label="Rolar para direita"
              type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m9 18 6-6-6-6"/>
              </svg>
            </button>
          </div>
        </b-row>
      </b-col>
    </b-row>

    <b-row v-if="selected.code === 1" class="m-0">
      <b-col class="px-0">
        <period-filters style="justify-content: space-between;" class="m-0 pr-2 mb-4 pl-2"/>

        <period-cards/>

        <payments-info/>

        <shippings-cards/>

        <customer-profile/>

        <graphs/>

        <visiting-info v-if="!is_multi_site_manager" class="mb-2"/>
      </b-col>
    </b-row>
    <!-- fim dashboard por período -->

    <b-row v-if="selected.code === 2" class="m-0">
      <b-col class="px-0">
        <status-info/>
      </b-col>
    </b-row>
    <!-- fim pedidos por status -->

    <b-row v-if="selected.code === 3" class="m-0">
      <b-col class="px-0">
        <abc-filters class="mb-4"/>

        <abc-curve/>
      </b-col>
    </b-row>
    <!-- fim dashboard contexto curva abc -->

    <b-row v-if="selected.code === 4" class="m-0">
      <b-col class="px-0">
        <stock-filters class="mb-4"/>

        <stock-info/>
      </b-col>
    </b-row>
    <!-- fim dashboard de estoques -->

    <b-row v-if="selected.code === 5" class="m-0">
      <b-col class="px-0">
        <sales-products-filters class="mb-4"/>

        <sales-info class="mb-4"/>

        <products-info/>
      </b-col>
    </b-row>
    <!-- fim dashboard de estatísticas de vendas e fim dashboard de produtos mais vendidos -->

    <b-row v-if="selected.code === 6" class="m-0">
      <b-col class="px-0">
        <receipt-visits-conversion-graph/>
      </b-col>
    </b-row>
    <!-- fim dashboard receitas / visitas / taxa de conversão -->

    <b-row v-if="selected.code === 7" class="m-0">
      <b-col class="px-0">
        <cancelled-bars/>

        <methods-info/>
      </b-col>
    </b-row>
    <!-- fim dashboard pedidos cancelados -->

    <b-row v-if="selected.code === 8" class="m-0">
      <b-col class="px-0">
        <ticket-progression-graph class="mb-4"/>

        <ticket-progression-cards/>
      </b-col>
    </b-row>
    <!-- fim dashboard progressão de ticket médio -->

    <b-row v-if="selected.code === 9" class="m-0">
      <b-col class="px-0">
        <shipping-costs/>

      </b-col>
    </b-row>
    <!-- fim custos de frete -->

    <b-row v-if="selected.code === 10" class="m-0">
      <b-col class="px-0">
        <funnel-sales-filters class="mb-4"/>

        <funnel-chart class="mb-4"/>
      </b-col>
    </b-row>
    <!-- fim funil de vendas e conversão -->

    <b-row v-if="selected.code === 11" class="m-0">
      <b-col class="px-0">
        <customer-behavior-filters class="mb-4"/>

        <customer-behavior-cards class="mb-4"/>

        <b-row class="m-0">
          <b-col lg="8" md="12" class="px-0">
            <customer-behavior-chart class="mb-4"/>
          </b-col>
          <b-col lg="4" md="12" class="px-0">
            <top-products-list />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- fim comportamento do cliente -->

    <b-row v-if="selected.code === 12" class="m-0">
      <b-col class="px-0">
        <sales-map/>
      </b-col>
    </b-row>
    <!-- fim mapa de vendas -->


  </b-container>
  <b-container fluid v-else-if="period_context_loaded" class="mt-4 text-12 px-4">
    <b-row class="django-like-alert-info m-0">
      <b-col>
        <b-row class="text-18">
          <strong>Dashboard da loja</strong>
        </b-row>
        <b-row>
          O seu usuário não possui permissão para visualizar o dashboard do administrativo.
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import HighCharts from 'highcharts'
require('highcharts/modules/exporting')(HighCharts);
require('highcharts/modules/drilldown')(HighCharts);
require('highcharts/modules/pareto')(HighCharts);

// Configurações globais para o HighCharts ====================================
// https://api.highcharts.com/highcharts/
HighCharts.setOptions({
  global: {
    canvasToolsURL: '',
  },
  lang:{
    decimalPoint: ',',
    thousandsSep: '.',
    drillUpText: '◁ Voltar para {series.name}',
    months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
             "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    shortMonths: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
                  "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
    weekdays: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
    printChart: 'Imprimir gráfico',
    downloadCSV: 'Baixar CSV',
    downloadJPEG: 'Baixar imagem JPEG',
    downloadPDF: 'Baixar documento PDF',
    downloadPNG: 'Baixar imagem PNG',
    downloadSVG: 'Baixar imagem em vetor SVG',
    downloadXLS: 'Baixar XLS',
    resetZoom: 'Redefinir zoom'
  },
  colors: ['#7ABA1E', '#FF524F', '#FCBC2C', '#0BA7DA', '#888888', '#AD55EA'],
  exporting: {
    buttons: {
      contextButton: {
        menuItems: ["printChart", "separator", "downloadPNG",
                    "downloadJPEG", "downloadPDF", "downloadSVG"],
      }
    }
  },
  credits: {
    enabled: true,
    href: '',
    position: {
      align: 'right',
      verticalAlign: 'bottom',
      x: -10,
      y: -5
    },
    style: {"cursor": "normal", "color": "#999999", "fontSize": "10px"},
    text: 'Highcharts.com'
  },
  title: {
    style: { "color": "#666666", "font-family": "'Open Sans', sans-serif" }
  },
  tooltip: {
    style: { "color": "#666666", "font-family": "'Open Sans', sans-serif" }
  }
});

import 'vue-loading-overlay/dist/vue-loading.css';

import PeriodFilters from '@/components/period_context/Filters.vue'
import PeriodCards from '@/components/period_context/PeriodCards.vue'
import PaymentsInfo from '@/components/period_context/PaymentsInfo.vue'
import ShippingsCards from '@/components/period_context/ShippingsCards.vue'
import CustomerProfile from '@/components/period_context/CustomerProfile.vue'
import Graphs from '@/components/period_context/Graphs.vue'
import VisitingInfo from '@/components/period_context/VisitingInfo.vue'
import StatusInfo from '@/components/status_context/StatusInfo.vue'
import StockFilters from '@/components/stock/Filters.vue'
import StockInfo from '@/components/stock/StockInfo.vue'
import SalesProductsFilters from '@/components/sales_products/Filters.vue'
import SalesInfo from '@/components/sales_products/SalesInfo.vue'
import ProductsInfo from '@/components/sales_products/ProductsInfo.vue'
import ReceiptVisitsConversionGraph from '@/components/receipt_visits_conversion_graph/ReceiptVisitsConversionGraph.vue'
import CancelledBars from '@/components/cancelled_context/CancelledBars.vue'
import MethodsInfo from '@/components/cancelled_context/MethodsInfo.vue'
import TicketProgressionGraph from '@/components/ticket_progression/Graph.vue'
import TicketProgressionCards from '@/components/ticket_progression/Cards.vue'
import AbcFilters from '@/components/curve_abc_context/Filters.vue'
import AbcCurve from '@/components/curve_abc_context/AbcCurve.vue'
import ShippingCosts from '@/components/shipping_costs/ShippingCosts.vue'
import FunnelSalesFilters from '@/components/funnel_sales_context/Filters.vue'
import FunnelChart from '@/components/funnel_sales_context/FunnelChart.vue'
import CustomerBehaviorFilters from '@/components/customer_behavior_context/Filters.vue'
import CustomerBehaviorCards from '@/components/customer_behavior_context/CustomerBehaviorCards.vue'
import CustomerBehaviorChart from '@/components/customer_behavior_context/CustomerBehaviorChart.vue'
import TopProductsList from '@/components/customer_behavior_context/TopProductsList.vue'
import SalesMap from '@/components/sales_map/SalesMap.vue'
import { getJsonCookie, setJsonCookie } from '@/services/cookie.service.js'

// Adição de contextos ========================================================
const CONTEXTS = [
  'Geral',
  'Pedidos',
  'Curva ABC',
  'Estoques',
  'Vendas',
  'Conversão',
  'Cancelados',
  'Ticket Médio',
  'Frete',
  'Funil de Vendas',
  'Fluxo de vendas'
]

function getOptions() {
  let arr = [];
  CONTEXTS.forEach(function (item, i) {
    if (item === 'Funil de Vendas') return;
    arr.push({ code: i+1, label: item });
  })
  // Adiciona "Mapa de Vendas" com code 12
  arr.push({ code: 12, label: 'Mapa de Vendas' });
  return arr;
}

// Ícones (Lucide-like) inline para cada contexto
const CONTEXT_ICONS = {
  1: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>',
  2: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-cart-icon lucide-shopping-cart"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>',
  3: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 17 9 11 13 15 21 7"/><polyline points="14 7 21 7 21 14"/></svg>',
  4: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-archive-icon lucide-archive"><rect width="20" height="5" x="2" y="3" rx="1"/><path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"/><path d="M10 12h4"/></svg>',
  5: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18"/><path d="M7 13l3 3 7-7"/></svg>',
  6: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-refresh-cw-icon lucide-refresh-cw"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/></svg>',
  7: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-x-icon lucide-circle-x"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>',
  8: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-ticket-icon lucide-ticket"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M13 5v2"/><path d="M13 17v2"/><path d="M13 11v2"/></svg>',
  9: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-truck-icon lucide-truck"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>',
  10:'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-funnel-icon lucide-funnel"><path d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z"/></svg>',
  11:'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-user-round-search-icon lucide-user-round-search"><circle cx="10" cy="8" r="5"/><path d="M2 21a8 8 0 0 1 10.434-7.62"/><circle cx="18" cy="18" r="3"/><path d="m22 22-1.9-1.9"/></svg>',
  12:'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-icon lucide-map"><polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/><line x1="9" y1="3" x2="9" y2="18"/><line x1="15" y1="6" x2="15" y2="21"/></svg>'
}

export default {
  mounted() {
    this.$store.commit('requestPeriodContext');
    const pinned = getJsonCookie('dashboard_pinned_tab', null);
    if (Array.isArray(pinned)) {
      // Remove o "Geral" (code: 1) e "Mapa de Vendas" (code: 12) dos fixados, pois já têm posição fixa
      this.pinnedTabCodes = pinned.filter(c => typeof c === 'number' && c !== 1 && c !== 10 && c !== 12);
    } else if (typeof pinned === 'number') {
      // compatibilidade com versão antiga (um único fixado)
      // Remove se for o "Geral", "Funil de Vendas" ou "Mapa de Vendas"
      this.pinnedTabCodes = (pinned === 1 || pinned === 10 || pinned === 12) ? [] : [pinned];
    }
    // Atualiza o cookie removendo o "Geral", "Funil de Vendas" ou "Mapa de Vendas" se estiver lá
    const hadRemovedTab = (Array.isArray(pinned) && (pinned.includes(1) || pinned.includes(10) || pinned.includes(12))) || pinned === 1 || pinned === 10 || pinned === 12;
    if (hadRemovedTab) {
      setJsonCookie('dashboard_pinned_tab', this.pinnedTabCodes);
    }
    
    // Adiciona suporte para scroll horizontal com mouse wheel e verifica botões
    this.$nextTick(() => {
      this.setupHorizontalScroll();
      // Verifica múltiplas vezes para garantir que detecta corretamente
      this.checkScrollButtons();
      setTimeout(() => this.checkScrollButtons(), 300);
      setTimeout(() => this.checkScrollButtons(), 600);
    });
    
    // Adiciona listener para resize da janela
    this.handleResize = () => {
      this.checkScrollButtons();
    };
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // Marca o componente como sendo destruído
    this._isBeingDestroyed = true;
    
    // Cancela qualquer timeout pendente
    if (this.hoverDebounceTimer) {
      clearTimeout(this.hoverDebounceTimer);
      this.hoverDebounceTimer = null;
    }
    
    // Remove o listener quando o componente for destruído
    if (this.contextTabsElement && typeof this.contextTabsElement.removeEventListener === 'function') {
      try {
        if (this.handleWheelScroll) {
          this.contextTabsElement.removeEventListener('wheel', this.handleWheelScroll);
        }
        if (this.onTabsScroll) {
          this.contextTabsElement.removeEventListener('scroll', this.onTabsScroll);
        }
      } catch (e) {
        console.warn('Erro ao remover listeners:', e);
      }
      this.contextTabsElement = null;
    }
    
    if (this.handleResize && typeof window !== 'undefined') {
      try {
        window.removeEventListener('resize', this.handleResize);
      } catch (e) {
        console.warn('Erro ao remover listener de resize:', e);
      }
      this.handleResize = null;
    }
    
    this.handleWheelScroll = null;
  },
  data: () => ({
    selected: {
      code: 1,
      label: 'visão geral por período (Clique aqui)'
    },
    options: getOptions(),
    pinnedTabCodes: [],
    contextTabsElement: null,
    handleWheelScroll: null,
    handleResize: null,
    showLeftButton: false,
    showRightButton: false
  }),
  name: 'App',
  components: {
    PeriodFilters,
    PeriodCards,
    PaymentsInfo,
    ShippingsCards,
    CustomerProfile,
    Graphs,
    VisitingInfo,
    StatusInfo,
    StockFilters,
    StockInfo,
    SalesProductsFilters,
    SalesInfo,
    ProductsInfo,
    ReceiptVisitsConversionGraph,
    CancelledBars,
    MethodsInfo,
    TicketProgressionGraph,
    TicketProgressionCards,
    AbcFilters,
    AbcCurve,
    ShippingCosts,
    FunnelSalesFilters,
    FunnelChart,
    CustomerBehaviorFilters,
    CustomerBehaviorCards,
    CustomerBehaviorChart,
    TopProductsList,
    SalesMap
  },
  computed: {
    sortedOptions() {
      // Tab "Geral" (code: 1) sempre primeiro
      const geral = this.options.find(o => o.code === 1);
      // "Mapa de Vendas" (code: 12) sempre no final
      const mapaVendas = this.options.find(o => o.code === 12);
      const outros = (() => {
        const semGeralEMapa = this.options.filter(o => o.code !== 1 && o.code !== 12);
        const comportamento = semGeralEMapa.find(o => o.code === 11);
        if (!comportamento) return semGeralEMapa;
        return [comportamento, ...semGeralEMapa.filter(o => o.code !== 11)];
      })();
      
      if (!this.pinnedTabCodes || this.pinnedTabCodes.length === 0) {
        return [geral, mapaVendas, ...outros].filter(Boolean);
      }
      
      const pinnedSet = new Set(this.pinnedTabCodes);
      // Remove o "Geral" e "Mapa de Vendas" dos fixados se estiver lá (não deve aparecer duplicado)
      const pinnedSetWithoutGeralEMapa = new Set([...pinnedSet].filter(code => code !== 1 && code !== 12));
      
      const pinned = outros.filter(o => pinnedSetWithoutGeralEMapa.has(o.code));
      const rest = outros.filter(o => !pinnedSetWithoutGeralEMapa.has(o.code));
      
      return [geral, mapaVendas, ...pinned, ...rest].filter(Boolean);
    },
    getContextIcon() {
      return (code) => CONTEXT_ICONS[code] || '';
    },
    is_multi_site_manager() { return this.$store.getters.is_multi_site_manager },
    isRequesting() { return this.$store.getters.isRequesting },
    period_context_loaded() { return this.$store.getters.period_context_loaded },
    user_has_dashboard_permission() { return this.$store.getters.user_has_dashboard_permission },
    status_context_loaded() { return this.$store.getters.status_context_loaded },
    stock_context_loaded() { return this.$store.getters.stock_context_loaded },
    sales_products_context_loaded() { return this.$store.getters.sales_products_context_loaded },
    receipt_visits_conversion_context_loaded() { return this.$store.getters.receipt_visits_conversion_context_loaded },
    cancelled_context_loaded() { return this.$store.getters.cancelled_context_loaded },
    ticket_progression_context_loaded() { return this.$store.getters.ticket_progression_context_loaded },
    abc_curve_context_loaded() { return this.$store.getters.abc_curve_context_loaded },
    shipping_costs_context_loaded() { return this.$store.getters.shipping_costs_context_loaded },
    funnel_sales_context_loaded() { return this.$store.getters.funnel_sales_context_loaded },
    live_cart_context_loaded() { return this.$store.getters.live_cart_context_loaded },
    customer_behavior_context_loaded() { return this.$store.getters.customer_behavior_context_loaded },
    sales_map_context_loaded() { return this.$store.getters.sales_map_context_loaded },
    site_id() { return this.$store.getters.site_id },
    analytics_loaded() { return this.$store.getters.analytics_loaded }
  },
  watch: {
    sortedOptions() {
      // Atualiza os botões quando as tabs mudarem
      this.$nextTick(() => {
        this.checkScrollButtons();
      });
    }
  },
  methods: {
    setupHorizontalScroll() {
      // Verifica se o componente ainda está montado
      if (this._isDestroyed || this._isBeingDestroyed) {
        return;
      }
      
      // Aguarda um pouco mais para garantir que o DOM está renderizado
      setTimeout(() => {
        // Verifica novamente após timeout
        if (this._isDestroyed || this._isBeingDestroyed) {
          return;
        }
        
        // Obtém a referência do elemento context-tabs
        let element = null;
        
        if (this.$refs && this.$refs.contextTabs) {
          // Bootstrap Vue pode expor o elemento de diferentes formas
          element = this.$refs.contextTabs.$el || this.$refs.contextTabs;
        }
        
        // Fallback: busca pelo seletor no DOM
        if (!element && this.$el && typeof this.$el.querySelector === 'function') {
          try {
            element = this.$el.querySelector('.context-tabs');
          } catch (e) {
            console.warn('Erro ao buscar elemento .context-tabs:', e);
          }
        }
        
        if (element && typeof element.addEventListener === 'function') {
          try {
            this.contextTabsElement = element;
            this.handleWheelScroll = (e) => {
              // Verifica se o elemento ainda existe e está montado
              if (this._isDestroyed || this._isBeingDestroyed || !element) {
                return;
              }
              
              try {
                // Só aplica scroll horizontal se houver conteúdo para rolar horizontalmente
                const hasHorizontalScroll = element.scrollWidth > element.clientWidth;
                
                if (hasHorizontalScroll) {
                  // Verifica se o scroll é principalmente vertical (deltaY maior que deltaX)
                  // ou se deltaX é muito pequeno (scroll puramente vertical do mouse)
                  if (Math.abs(e.deltaY) > Math.abs(e.deltaX) || Math.abs(e.deltaX) < 5) {
                    // Previne o comportamento padrão de scroll vertical
                    e.preventDefault();
                    // Converte o scroll vertical em horizontal
                    element.scrollLeft += e.deltaY;
                  }
                }
              } catch (err) {
                console.warn('Erro ao processar scroll:', err);
              }
            };
            element.addEventListener('wheel', this.handleWheelScroll, { passive: false });
            // Adiciona listener de scroll para atualizar os botões
            if (this.onTabsScroll) {
              element.addEventListener('scroll', this.onTabsScroll);
            }
          } catch (e) {
            console.warn('Erro ao configurar scroll horizontal:', e);
          }
        }
      }, 100);
    },
    checkScrollButtons() {
      // Verifica se o componente ainda está montado antes de executar
      if (this._isDestroyed || this._isBeingDestroyed) {
        return;
      }
      
      this.$nextTick(() => {
        // Verifica novamente após $nextTick
        if (this._isDestroyed || this._isBeingDestroyed) {
          return;
        }
        
        setTimeout(() => {
          // Verifica novamente após timeout
          if (this._isDestroyed || this._isBeingDestroyed) {
            return;
          }
          
          const element = this.getTabsElement();
          if (element && typeof element.scrollWidth !== 'undefined') {
            try {
              const scrollWidth = element.scrollWidth;
              const clientWidth = element.clientWidth;
              const scrollLeft = element.scrollLeft;
              const hasHorizontalScroll = scrollWidth > clientWidth + 2; // Margem de 2px
              
              // Adiciona uma margem de erro de 2px para evitar problemas de arredondamento
              const isAtStart = scrollLeft <= 2;
              const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 2;
              
              this.showLeftButton = hasHorizontalScroll && !isAtStart;
              this.showRightButton = hasHorizontalScroll && !isAtEnd;
            } catch (e) {
              console.warn('Erro ao verificar botões de scroll:', e);
            }
          } else {
            // Se não encontrou o elemento e o componente ainda está montado, tenta novamente depois
            if (!this._isDestroyed && !this._isBeingDestroyed) {
              setTimeout(() => this.checkScrollButtons(), 200);
            }
          }
        }, 150);
      });
    },
    getTabsElement() {
      // Verifica se o componente ainda está montado
      if (this._isDestroyed === true || this._isBeingDestroyed === true) {
        return null;
      }
      
      if (this.contextTabsElement) {
        return this.contextTabsElement;
      }
      
      if (this.$refs && this.$refs.contextTabs) {
        const refElement = this.$refs.contextTabs.$el || this.$refs.contextTabs;
        if (refElement) {
          return refElement;
        }
      }
      
      // Verifica se $el existe e é um elemento DOM válido antes de usar querySelector
      if (this.$el && typeof this.$el.querySelector === 'function') {
        try {
          return this.$el.querySelector('.context-tabs');
        } catch (e) {
          console.warn('Erro ao buscar elemento .context-tabs no $el:', e);
          return null;
        }
      }
      
      return null;
    },
    scrollLeft() {
      if (this._isDestroyed || this._isBeingDestroyed) {
        return;
      }
      
      const element = this.getTabsElement();
      if (element && typeof element.scrollTo === 'function' && typeof element.scrollLeft !== 'undefined') {
        try {
          element.scrollTo({
            left: element.scrollLeft - 200,
            behavior: 'smooth'
          });
        } catch (e) {
          console.warn('Erro ao fazer scroll para esquerda:', e);
        }
      }
    },
    scrollRight() {
      if (this._isDestroyed || this._isBeingDestroyed) {
        return;
      }
      
      const element = this.getTabsElement();
      if (element && typeof element.scrollTo === 'function' && typeof element.scrollLeft !== 'undefined') {
        try {
          element.scrollTo({
            left: element.scrollLeft + 200,
            behavior: 'smooth'
          });
        } catch (e) {
          console.warn('Erro ao fazer scroll para direita:', e);
        }
      }
    },
    onTabsScroll() {
      // Verifica se o componente ainda está montado antes de verificar os botões
      if (!this._isDestroyed && !this._isBeingDestroyed) {
        this.checkScrollButtons();
      }
    },
    isPinned(code) {
      // "Geral" e "Mapa de Vendas" nunca são considerados fixados, pois já têm posição fixa
      if (code === 1 || code === 12) return false;
      return Array.isArray(this.pinnedTabCodes) && this.pinnedTabCodes.includes(code);
    },
    togglePin(opt) {
      // Não permite fixar o tab "Geral" (code: 1) e "Mapa de Vendas" (code: 12)
      if (opt.code === 1 || opt.code === 12) return;
      
      if (!Array.isArray(this.pinnedTabCodes)) this.pinnedTabCodes = [];
      const idx = this.pinnedTabCodes.indexOf(opt.code);
      if (idx >= 0) {
        this.pinnedTabCodes.splice(idx, 1);
      } else {
        this.pinnedTabCodes.push(opt.code);
      }
      setJsonCookie('dashboard_pinned_tab', this.pinnedTabCodes);
    },
    onSelectContext(opt) {
      this.selected = opt;
      this.switchContext();
    },
    switchContext() {
      let url;
      let period;
      if (this.user_has_dashboard_permission) {
        switch (this.selected.code) {
          case 1:
            if (!this.period_context_loaded)
              this.$store.commit('requestPeriodContext');
            return;  // Além de ser o inicial ele possui uma requisição diferente
          case 2:
            if (!this.status_context_loaded)
              url = 'order/dashboard/order_status_context/';
            break;
          case 3:
            if (!this.abc_curve_context_loaded) {
              url = 'order/dashboard/order_curve_abc_context/';
              period = 7;  // initial period
            }
            break;
          case 4:
            if (!this.stock_context_loaded)
              url = 'product/dashboard/product/';
            break;
          case 5:
            if (!this.sales_products_context_loaded)
              url = 'order/dashboard/order_sales_products_context/';
            break;
          case 6:
            if (!this.receipt_visits_conversion_context_loaded)
              url = 'order/dashboard/receipt_visits_conversion/';
            break;
          case 7:
            if (!this.cancelled_context_loaded)
              url = 'order/dashboard/order_cancelled_context/';
            break;
          case 8:
            if (!this.ticket_progression_context_loaded)
              url = 'order/dashboard/order_ticket_progression_context/';
            break;
          case 9:
            if (!this.shipping_costs_context_loaded)
              url = 'order/dashboard/shipping_costs_context/';
            break;
          case 10: {
            // SEMPRE buscar dados ao entrar no funil (independente do estado)
            const initialFunnelPeriod = this.$store.getters.funnelPeriodSelectedIndex;
            const initialFunnelOrigin = this.$store.getters.funnelOriginSelectedCode;
            
            console.log('[MAIN] Entrando no Fluxo de Vendas - Período:', initialFunnelPeriod);
            
            // Resetar estado do funil antes de buscar (garante request limpo)
            this.$store.commit('resetFunnelSalesContext');
            
            // Fazer request ao analytics e buscar dados do funil
            this.$store.commit('updateFunnelSalesContext', {
              'period': initialFunnelPeriod,
              'site_or_order_origin': initialFunnelOrigin
            });
            return;
          }
          case 11:
            if (!this.customer_behavior_context_loaded) {
              // Para o comportamento do cliente, precisamos buscar dados do funil e analytics
              this.$store.dispatch('requestCustomerBehaviorData', {
                'period': this.$store.getters.customerBehaviorPeriodSelectedIndex,
                'site_or_order_origin': this.$store.getters.customerBehaviorOriginSelectedCode,
                'skipOrderContextRefresh': true
              });
            }
            return;
          case 12:
            if (!this.sales_map_context_loaded) {
              const params = new URLSearchParams();
              params.append('arquivado', '0');
              params.append('period', '6'); // Mês atual por padrão
              params.append('t', new Date().getTime());
              const queryString = params.toString();
              url = `reports/national-map/percentage/?${queryString}`;
            }
            break;
        }
        if (url) {
          this.$store.commit('requestCommonContext', {
            'url': url, 'period': period
          });
        }
      }
    },
  }
};
</script>

<style>
  .django-like-alert-info {
    color: #3a87ad;
    background-color: #d9edf7;
    padding: 14px 35px 14px 14px;
    margin-bottom: 18px;
    border: 1px solid #bce8f1;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
  }

  /* Tabs de contexto no header */
  .context-tabs .nav-link {
    border: 1px solid #CCCCCC;
    color: #666;
    background-color: #fff;
    border-radius: 16px;
    line-height: 1.1;
    position: relative;
  }
  /* Wrapper das tabs com botões de scroll */
  .context-tabs-wrapper {
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    overflow: visible;
    min-width: 0; /* Permite que o flex shrink funcione */
  }
  /* Container das abas com scroll oculto */
  .context-tabs {
    position: relative;
    scrollbar-width: none;              /* Firefox: esconde */
    padding-right: 0;
    width: 100%;
    justify-content: space-between;
  }
  .context-tabs::-webkit-scrollbar { height: 0; background: transparent; }
  .context-tabs::-webkit-scrollbar-track { background: transparent; }
  .context-tabs::-webkit-scrollbar-thumb { background-color: transparent; }
  .nav-item-wrap { display: inline-flex; align-items: center; gap: 8px; position: relative; }
  .context-tabs .nav-link.active,
  .context-tabs .nav-link:focus,
  .context-tabs .nav-link:hover {
    background-color: #000000 !important;
    border-color: #000000 !important;
    color: #fff !important;
  }

  /* Estado visual para abas fixadas (não ativas): verde bem clarinho */
  .context-tabs .nav-link.pinned {
    background-color: #ECF7E3; /* verde clarinho derivado do #7ABA1E */
    border-color: #CBE9AB;
    color: #000000;
  }

  .nav-item-wrap { display: inline-flex; align-items: center; gap: 8px; position: relative; }
  .ctx-icon svg { vertical-align: middle; }
  .ctx-badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 8px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    position: absolute;
    top: -12px;
    right: -21px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.12);
    transition: right 0.3s ease;
  }
  .ctx-badge--new {
    background-color: #8055d5;
    color: #fff;
  }

  /* Botão de alfinete (fixar) */
  .pin-btn {
    position: absolute;
    top: -10px;
    right: -24px;
    background: #fff;
    border: 1px solid #CCCCCC;
    border-radius: 50%;
    padding: 2px;
    line-height: 0;
    color: #888;
    box-shadow: 0 1px 2px rgba(0,0,0,0.08);
    opacity: 0;
    transform: translateY(-4px) scale(0.8);
    transition: opacity 160ms ease, transform 200ms ease;
  }
  .context-tabs .nav-link:hover .pin-btn,
  .context-tabs .nav-link:focus .pin-btn {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  .pin-btn.visible { opacity: 1; transform: translateY(0) scale(1); }
  .pin-btn:hover { color: #000000; border-color: #000000; }
  .context-tabs .nav-link:hover .ctx-badge,
  .context-tabs .nav-link:focus .ctx-badge {
    transition: right 0.3s ease;
    right: 0;
  }

  /* Botões de scroll horizontal */
  .scroll-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #fff;
    border: 1px solid #CCCCCC;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1000;
    color: #666;
    transition: all 0.2s ease;
    padding: 0;
  }
  .scroll-btn:hover {
    background-color: #000000;
    border-color: #000000;
    color: #fff;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
  }
  .scroll-btn:active {
    transform: translateY(-50%) scale(0.95);
  }
  .scroll-btn-left {
    left: -12px;
  }
  .scroll-btn-right {
    right: -12px;
  }
  .scroll-btn svg {
    width: 16px;
    height: 16px;
  }
</style>
